// extracted by mini-css-extract-plugin
export default {"content":"vI-z","lookName":"wI-z","shopTheLookContainer":"xI-z","productContainer":"yI-z","imageContainer":"zI-z","mainImage":"AI-z"};